import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuState = new BehaviorSubject<boolean>(false);
  menuOpen$ = this.menuState.asObservable();
  constructor() { }

  toggleMenu() {
    this.menuState.next(!this.menuState.value);
  }
  
  openMenu() {
    this.menuState.next(true);
  }

  closeMenu() {
    this.menuState.next(false);
  }
}
